import React from 'react'
import {
    Row,
    Col,
    Button,
    Form,
    FloatingLabel,
  } from "react-bootstrap";
const Contactform = () => {
    return (
        <div>
             <div className="contact-banner">
               
                <Form>
                  <Row className="g-2">
                    <Col md>
                      <FloatingLabel
                        controlId="floatingInputGrid"
                        label="Full Name"
                      >
                        <Form.Control
                          type="text"
                          placeholder="Enter Your Full Name Here"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col md>
                      <FloatingLabel
                        controlId="floatingInputGrid"
                        label="Phone Number"
                      >
                        <Form.Control
                          type="text"
                          placeholder="Enter Your Phone Number Here"
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row className="g-2 mt-02">
                    <Col md>
                      <FloatingLabel
                        controlId="floatingInputGrid"
                        label="Email Address"
                      >
                        <Form.Control
                          type="email"
                          placeholder="name@example.com"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col md>
                      <FloatingLabel
                        controlId="floatingSelectGrid"
                        label="Service"
                      >
                        <Form.Select aria-label="Floating label select example">
                          <option>Choose Service</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                   
                  </Row>
                  <Row className="g-2 mt-02">
                  <Col md={12}>
                      <FloatingLabel
                        controlId="floatingInputGrid"
                        label="Subject"
                      >
                        <Form.Control
                          type="text"
                          placeholder="Subject"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col>
                    <FloatingLabel
                      controlId="floatingTextarea2"
                      label="Comments"
                    >
                      <Form.Control
                        as="textarea"
                        placeholder="Leave a comment here"
                        style={{ height: "100px" }}
                      />
                    </FloatingLabel>
                    </Col>
                  </Row>
                  <Button variant="primary" type="submit" className="mt-20">
                    Submit
                  </Button>
                </Form>
                
              </div>
        </div>
    )
}

export default Contactform
